<template>
	<form-ingredient-list ref="form-ingredient" :isShowError="showError" @change="changeIngredient"></form-ingredient-list>
</template>
<script>
import FormIngredientList from '@/views/common/components/form/ingredient/FormIngredientList.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'ItemFormIngredientList',
	components: { FormIngredientList },
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapGetters('inventoryGen2/form', ['item', 'showError']),
	},
	watch: {},
	created() {},
	mounted() {
		this.$nextTick(() => {
			this.$refs['form-ingredient'].setData(this.item?.ingredient)
		})
	},
	methods: {
		...mapMutations('inventoryGen2/form', ['setIngredientInfo']),
		changeIngredient(value) {
			this.setIngredientInfo(value)
		},
		showRequire() {
			this.$refs['form-ingredient'].showRequire()
		},
	},
}
</script>

<style lang="scss" scoped></style>
